// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const foodSensoryIntakeQuestionId = (z.number());
export const foodSensoryIntakeQuestion = z.object({
    id: foodSensoryIntakeQuestionId,
    prompt: z.string(),
    passing_answer: z.boolean().nullable(),
    stop_reason: z.string().nullable(),
    reply_yes: z.string().nullable(),
    reply_no: z.string().nullable(),
    display_order: z.number(),
    archived_at: z.date().nullable(),
    archived_by: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const foodSensoryIntakeQuestionInitializer = z.object({
    id: foodSensoryIntakeQuestionId.optional(),
    prompt: z.string().optional(),
    passing_answer: z.boolean().optional().nullable(),
    stop_reason: z.string().optional().nullable(),
    reply_yes: z.string().optional().nullable(),
    reply_no: z.string().optional().nullable(),
    display_order: z.number().optional(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const foodSensoryIntakeQuestionMutator = z.object({
    id: foodSensoryIntakeQuestionId.optional(),
    prompt: z.string().optional(),
    passing_answer: z.boolean().optional().nullable(),
    stop_reason: z.string().optional().nullable(),
    reply_yes: z.string().optional().nullable(),
    reply_no: z.string().optional().nullable(),
    display_order: z.number().optional(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FoodSensoryIntakeQuestion.js.map